<template>
  <dl class="input-block">
    <dt>ぐるなびネット予約クーポン</dt>
    <dd>
      <textarea class="textarea" rows="4" v-model="val" ref="textarea" disabled></textarea>
    </dd>
  </dl>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NetReservationCoupon',
  computed: {
    ...mapState({
      coupon: state => state.reserves.edit.reservation.coupon,
    }),
    val() {
      return `${this.coupon.title}\n${this.coupon.text || ''}`
    },
  },
  mounted() {
    this.setHeight()
  },
  methods: {
    setHeight() {
      const textarea = this.$refs.textarea
      textarea.style.height = textarea.scrollHeight + 'px'
    },
  },
}
</script>

<style lang="postcss" scoped>
textarea {
  line-height: 1.7;
  overflow: hidden;
  resize: none;

  &:disabled {
    background: rgba(239, 239, 239, 0.3);
    color: initial;
    opacity: 1;
  }
}
</style>
